import { Directive } from "@angular/core";

@Directive()
export abstract class Controller {
	protected abstract get apiUrl(): string;
}
